import { Typography, withStyles, withTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'react-layout-components';
import { Animated, Easing } from 'react-native-web';
import { withRouter } from 'react-router-dom';
import FadeFromDown from '../transitions/FadeFromDown';
import Container from './Container';
import Typing from './MTyping';
import Spacing from './Spacing';
import Toolbar from './Toolbar';


class HomeHeader extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            showAnimatedElements: false,
            currentMessageSet: undefined,
            typing: false
        }
    }

    asyncSetState = (state) =>
        new Promise(a => requestAnimationFrame(() => this.setState({ ...this.state, ...state }, a)))

    componentDidMount() {
        this.asyncSetState({ showAnimatedElements: true })

        this.messagesInterval = setTimeout(this.doFowardMessage, 0)
    }

    componentWillUnmount() {
        clearInterval(this.messagesInterval)
    }

    getNextDelay = () => {
        if (!this.lastDelay)
            this.lastDelay = 0
        this.lastDelay += 200
        return this.lastDelay
    }

    doFowardMessage = () => {
        this.setState({
            currentMessageSet: undefined
        }, () => {
            setTimeout(() => {
                this.setState({
                    ...this.state,
                    currentMessageSet: HEADER_MESSAGES[parseInt(Math.random() * HEADER_MESSAGES.length, 10)]
                })
            }, 5800)
        })
    }

    setTyping = typing => {
        const elements = document.getElementsByClassName('typing-white-ballon-dot_')
        if (typing) {
            elements[0].classList.add('typing-white-ballon-dot')
            elements[1].classList.add('typing-white-ballon-dot')
            elements[2].classList.add('typing-white-ballon-dot')
        } else {
            elements[0].classList.remove('typing-white-ballon-dot')
            elements[1].classList.remove('typing-white-ballon-dot')
            elements[2].classList.remove('typing-white-ballon-dot')
        }
    }

    doScrollTo = elementId => {
        const node = document.getElementById(elementId)
        const scrollElement = document.getElementById('scroll')

        if (node && scrollElement) {
            const nodeTop = node.offsetTop

            const scrollPos = new Animated.Value(scrollElement.scrollTop)

            Animated
                .timing(scrollPos, {
                    toValue: nodeTop - 56,
                    duration: 800,
                    easing: Easing.bezier(.8, .2, .2, .8)
                })
                .start()

            scrollPos.addListener(({ value }) => {
                scrollElement.scrollTop = value
            })
        }
    }

    render() {

        const { classes, lightToolbar } = this.props
        const { currentMessageSet } = this.state
        const Message = currentMessageSet

        return (
            <Box column className={classes.root} center>
                <Box column className={classes.colorBackground} />

                <Toolbar light={lightToolbar} elevated={lightToolbar} />

                <FadeFromDown visible>
                    <Container className={classes.content} center>
                        <Box className={classes.contentBox} center justifyContent="space-between">
                            <Box column>
                                <Typography className={classes.headerTitle}>
                                    A Melhor Solução <br/>de Marketing Digital <br/>Para Sua Empresa
                                </Typography>
                                <Typography className={classes.headerSubtitle}>
                                    Mostre sua empresa ou produto para o público <br/>certo através das principais redes sociais
                                </Typography>
                            </Box>

                            <Spacing large/>

                            <img className={classes.headerRightImage} src="/images/hd-comp.png" />
                        </Box>
                    </Container>
                </FadeFromDown>
            </Box>
        )
    }

}

HomeHeader.propTypes = {
    classes: PropTypes.any,
    lightToolbar: PropTypes.bool
}

HomeHeader.defaultProps = {

}

const styles = theme => ({
    root: {
        position: 'relative',
        width: '100%',
        minHeight: `80vh`,
        paddingTop: 64 + 32,
        paddingBottom: 64 + 32,
        color: theme.palette.primary.contrastText,
        overflow: 'hidden'
    },
    colorBackground: {
        position: 'absolute',
        top: 0,
        bottom: 4,
        left: 0,
        right: 0,
        zIndex: 0
    },
    imageBackground: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 0,
        background: `url(/images/header-bg.svg) center / cover`,
    },
    typingContent: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
    content: {
        height: '100%',
        position: 'relative',
        zIndex: 10
    },
    contentBox: {
        width: '100%',
        height: '100%',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row'
        }
    },
    headerLeft: {

    },
    headerRight: {
        position: 'relative',
        [theme.breakpoints.down('xs')]: {
            fontSize: 52,
            marginLeft: 0
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: 84,
            marginLeft: 24
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: 96,
            marginLeft: 32
        },
    },
    headerRightBottom: {
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            alignItems: 'flex-start',
            position: 'absolute',
            top: '100%',
        }
    },
    headerLogo: {
        [theme.breakpoints.down('xs')]: {
            width: 96,
        },
        [theme.breakpoints.up('sm')]: {
            width: 192
        },
        [theme.breakpoints.up('lg')]: {
            width: 240
        },
    },
    headerTitle: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 24,
            textAlign: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: 28
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: 36
        },
        fontWeight: '700',
        margin: 0,
        letterSpacing: 1.1,
        lineHeight: 1.3,
        fontFamily: 'Montserrat',
        color: theme.palette.primary.main
    },
    headerTitleSmall: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 52 * .4,
            textAlign: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: 84 * .4
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: 96 * .4
        },
        fontWeight: '900',
        margin: 0,
        lineHeight: 1,
        color: theme.palette.grey['700'],
        fontFamily: 'Montserrat',
        textAlign: 'center'
    },
    headerSubtitle: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 52 * 0.21,
            textAlign: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: 84 * 0.21
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: 96 * 0.21
        },
        fontWeight: '400',
        fontFamily: 'Montserrat',
        margin: 0,
        marginTop: 16,
        marginBottom: 32,
        letterSpacing: 1.1,
        lineHeight: 1.3,
        opacity: .8,
        color: theme.palette.grey['700'],
    },
    headerRightButton: {
        [theme.breakpoints.down('xs')]: {
            marginLeft: 16
        },
        [theme.breakpoints.up('sm')]: {
            marginLeft: 16
        },
        [theme.breakpoints.up('lg')]: {
            marginLeft: 16
        },
    },
    cursor: {
        color: theme.palette.primary.contrastText
    },
    typingAvatar: {
        position: 'relative',
        width: 96,
        height: 96,
        borderRadius: 192,
        overflow: 'hidden',
        boxShadow: `0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2)`
    },
    typingWhiteBallon: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        backgroundColor: '#FFFFFF',
        width: 96 / 3,
        height: 96 / 3,
        borderRadius: 192,
        boxShadow: `0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2)`
    },
    typingWhiteBallonDot: {
        backgroundColor: theme.palette.primary.main,
        width: 6,
        height: 6,
        margin: 1,
        borderRadius: 192,
        animationTimingFunction: 'cubic-bezier(.6, .4, .4, .6)'
    },
    headerRightImage: {
        [theme.breakpoints.down('xs')]: {
            width: 300
        },
        [theme.breakpoints.up('sm')]: {
            width: 360
        },
        [theme.breakpoints.up('lg')]: {
            width: 560
        },
    }
})


const HEADER_MESSAGES_TEXTS = [
    [
        'Olá! Seja bem vindo =)',
        'Que tal tirar aquela ideia do papel?',
        'Podemos transformá-la em um lindo site ou aplicativo!',
        'Divulge seu produto com o que há de mais moderno em marketing digital!',
        'Entre em contato, e vamos tomar um café <3'
    ],
    [
        'Olá! Gostou do nosso site?',
        'Ele foi feito pensando em você =)',
        'Sua ideia também merece um visual como este!',
    ],
    [
        'Somos apaixonados por novas ideias <3',
        'Seu produto precisa de uma solução moderna e inteligente!',
        'Explore nosso site, e veja o que podemos fazer ;)'
    ],
]

const MessageSet1 = withStyles(styles)(
    class extends React.PureComponent {
        render() {
            const { classes, onFinishedTyping, onStarted, onStopped } = this.props

            return (
                <Typing
                    onStarted={onStarted}
                    onStopped={onStopped}
                    onFinishedTyping={onFinishedTyping}
                    startDelay={400}
                    speed={80}
                    cursorClassName={classes.cursor}>
                    <Box>
                        <Typing.Delay ms={2600} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[0][0]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[0][0].length} delay={HEADER_MESSAGES_TEXTS[0][0].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[0][1]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[0][1].length} delay={HEADER_MESSAGES_TEXTS[0][1].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[0][2]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[0][2].length} delay={HEADER_MESSAGES_TEXTS[0][2].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[0][3]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[0][3].length} delay={HEADER_MESSAGES_TEXTS[0][3].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[0][4]}</span>
                        <Typing.Delay ms={HEADER_MESSAGES_TEXTS[0][3].length * 50 * 1.5} />
                    </Box>
                </Typing>
            )
        }
    }
)

const MessageSet2 = withStyles(styles)(
    class extends React.PureComponent {
        render() {
            const { classes, onFinishedTyping, onStarted, onStopped } = this.props

            return (
                <Typing
                    onStarted={onStarted}
                    onStopped={onStopped}
                    onFinishedTyping={onFinishedTyping}
                    startDelay={400}
                    speed={80}
                    cursorClassName={classes.cursor}>
                    <Box>
                        <Typing.Delay ms={2600} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[1][0]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[1][0].length} delay={HEADER_MESSAGES_TEXTS[1][0].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[1][1]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[1][1].length} delay={HEADER_MESSAGES_TEXTS[1][1].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[1][2]}</span>
                        <Typing.Delay ms={HEADER_MESSAGES_TEXTS[1][2].length * 50 * 1.5} />
                    </Box>
                </Typing>
            )
        }
    }
)

const MessageSet3 = withStyles(styles)(
    class extends React.PureComponent {
        render() {
            const { classes, onFinishedTyping, onStarted, onStopped } = this.props

            return (
                <Typing
                    onStarted={onStarted}
                    onStopped={onStopped}
                    onFinishedTyping={onFinishedTyping}
                    startDelay={400}
                    speed={80}
                    cursorClassName={classes.cursor}>
                    <Box>
                        <Typing.Delay ms={2600} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[2][0]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[2][0].length} delay={HEADER_MESSAGES_TEXTS[2][0].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[2][1]}</span>
                        <Typing.Backspace count={HEADER_MESSAGES_TEXTS[2][1].length} delay={HEADER_MESSAGES_TEXTS[2][1].length * 50 * 1.5} speed={20} />
                        <Typing.Delay ms={200} />
                        <Typing.Speed ms={60} />
                        <span className={classes.headerTitleSmall}>{HEADER_MESSAGES_TEXTS[2][2]}</span>
                        <Typing.Delay ms={HEADER_MESSAGES_TEXTS[2][2].length * 50 * 1.5} />
                    </Box>
                </Typing>
            )
        }
    }
)

const HEADER_MESSAGES = [
    props => <MessageSet1 {...props} />,
    props => <MessageSet2 {...props} />,
    props => <MessageSet3 {...props} />,
]

export default withRouter(withTheme()(withStyles(styles)(HomeHeader)))


// WEBPACK FOOTER //
// ./src/components/common/HomeHeader.js